var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEmail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Inbox_Icon",
    "data-name": "Inbox Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Frame",
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email",
    transform: "translate(1.491 -71.389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13035",
    "data-name": "Group 13035",
    transform: "translate(0 76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5785",
    "data-name": "Path 5785",
    d: "M19.17,76H1.847A1.85,1.85,0,0,0,0,77.847V88.931a1.85,1.85,0,0,0,1.847,1.847H19.17a1.85,1.85,0,0,0,1.847-1.847V77.847A1.85,1.85,0,0,0,19.17,76Zm-.284,1.231-7.9,7.926a.719.719,0,0,1-.954,0l-7.9-7.926ZM1.231,88.7V78.074l5.3,5.315Zm.9.842L7.4,84.261l1.76,1.766a1.949,1.949,0,0,0,2.7,0l1.76-1.766,5.268,5.285ZM19.786,88.7l-5.3-5.315,5.3-5.315Z",
    transform: "translate(0 -76)",
    fill: "#da291c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/icon_email.bd177f2b8f28ed7311a9752d903eff0e.svg";
export { ForwardRef as ReactComponent };